import { render, staticRenderFns } from "./PagesRelatedProductsWidget.vue?vue&type=template&id=dd0482ba&"
import script from "./PagesRelatedProductsWidget.vue?vue&type=script&lang=js&"
export * from "./PagesRelatedProductsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports